
export class I18n {
    constructor(private tmhDynamicLocale,  private $translate){

    }

    public getLanguage() {
        return this.$translate.use();
    }

    public setLanguage(lang) {
        this.$translate.preferredLanguage(lang);

        let lang_arr = lang.split('_');
        if(lang_arr.length > 1){
            //bug in java country code specification in hebrew. It should be he instead of il
            if(lang_arr[0] === 'iw') {
                lang_arr[0] = 'he';
            }
            lang_arr[1]= lang_arr[1].toLowerCase();
        }
        this.tmhDynamicLocale.set(lang_arr.join('-'));
        return this.$translate.use(lang);
    }


}

I18n.$inject = ['tmhDynamicLocale', '$translate'];


// WEBPACK FOOTER //
// ./src/main/webapp/components/i18n/I18n.service.ts